import { matchPath } from "react-router-dom";

export default class SearchRoute {
  currentRoute = null;
  params = null;
  searchBy = null;
  pageUrl = "";
  match = null;
  matchPath = window.location.pathname;

  constructor(pageUrl, routes, matchPath = null) {
    this.pageUrl = pageUrl;
    if (matchPath) this.matchPath = matchPath;
    if (routes.length) this.checkForMatch(routes);
  }

  checkForMatch = routes => {
    for (const route of routes) {
      const path = `${this.pageUrl}${route.path}`;
      const match = matchPath(this.matchPath, { path });
      if (match && match.isExact) {
        this.currentRoute = route;
        this.params = match.params;
        this.searchBy = route.filters ? route.filters.journey : route.path.split("/")[1];
        this.match = match;
      }
    }
  };

  getInitialQuery = () => {
    const params = this.getParams();
    Object.keys(params).forEach(function(key) {
      if (key !== 'type' && params[key] && (typeof params[key] === 'string' || params[key] instanceof String)) {
        params[key] = params[key].replaceAll('%20','-').replaceAll(' ',"-");
      }
    })
    const route = this.getRoute();
    const searchBy = this.getSearchBy();
    const query = Object.entries(params).reduce((result, [param, value]) => {
      if (value && (value.length !== 2 || value[0] !== '0')) {
        if (!isNaN(value)) value = Number(value);
      }
      if (value) result = { ...result, [param]: value };
      return result;
    }, {});

    const addRouteParamsQuery = query => {
      let routeQuery = query;
      for (const param of route.params) {
        const { name, divider, filters } = param;
        let values = params[name] ? params[name].split(divider) : [];
        if (values.length) {
          values = values.reduce((result, value, i) => {
            return { ...result, [filters[i]]: value };
          }, {});
          routeQuery = { ...routeQuery, ...values };
        }
        delete routeQuery[name];
      }
      return routeQuery;
    };

    const routeParamsQuery = route.params ? addRouteParamsQuery(query) : query;
    const routeFiltersQuery = route.filters
      ? { ...routeParamsQuery, ...route.filters }
      : routeParamsQuery;
    return { searchBy, ...routeFiltersQuery };
  };

  getMatch = () => this.match;

  getParams = () => this.params;

  getRoute = () => this.currentRoute;

  getSearchBy = () => this.searchBy;
}
